import React from "react";
import styled from "styled-components";
import { Modal, Spinner } from "react-rainbow-components";
import ExchangeIcon from "./ExchangeIcon";
import axios from "axios";
import { UserContext } from "../../store/UserStore";
import { useError } from "../../store/ErrorModal";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
`;

const ExchangeDataContainer = styled.div`
  display: flex;
  margin: 0.5rem;
  width: calc(100% - 7rem);
  justify-content: space-around;
  align-items: center;

  div.exchange {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
    width: 7rem;
    text-align: center;
    justify-content: center;
  }
`;

/*
    props.status === success
      ? "#0DD07E"
      :
*/
const DropdownButton = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  padding: 0.5rem 1rem;
  border: 0px;
  outline-width: 0;
  border-radius: 16px;
  text-align-last: center;

  background-color: ${(props: { status?: number }) =>
    props.status === 0
      ? "rgba(229, 37, 65, 0.8)"
      : props.status === 1
      ? "#FFD92E"
      : props.status === 2
      ? "#4779F4"
      : props.status === 3
      ? "#0dd07e"
      : "#CA33CD"};
  color: #fff;
  &::-ms-expand {
    display: none;
  }

  option {
    padding: 0.25rem;
    background-color: #fff;
    color: #123559;
  }

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    option {
      font-size: 0.8rem;
      background-color: #fff;
      color: #123559;
    }
  }
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;

  h1 {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 0;
    margin-bottom: 1rem;
  }
`;

const ButtonContainer = styled.section`
  display: flex;
  justify-content: space-around;
  margin-top: 0.5rem;
  width: calc(100% - 7rem);
`;

const ConfirmButton = styled.button`
  background-color: #0dd07e;
  color: #fff;
  border-radius: 20px;
  margin: 1rem 0rem;
  border: 3px solid #0dd07e;
  width: 10rem;
`;

const CancelButton = styled.button`
  background-color: #fff;
  border-radius: 20px;
  margin: 1rem 0rem;
  padding: 0.5rem;
  border: 3px solid #0dd07e;
  width: 10rem;
`;

const ChangeStatusComponent = (props: {
  status: number;
  bookingId: string;
  uid: string;
  fetchData: () => void;
}) => {
  const [isOpenChange, setIsOpenChange] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<number>(props.status);
  const [value, SetValue] = React.useState<number>(props.status);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const userContext = React.useContext(UserContext);
  const { onError } = useError();

  const statusLabel: string[] = [
    "ยังไม่ชำระเงิน",
    "ชำระเงินแล้ว",
    "กำลังให้บริการ",
    "สำเร็จ",
  ];

  const OnChangeModal = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setIsOpenChange(!isOpenChange);
    SetValue(parseInt(e.currentTarget.value));
  };

  const ConfirmModal = async () => {
    setIsLoading(true);
    try {
      await axios.patch(`/booking/${props.bookingId}`, {
        adminApproved: value !== 0 && `admin:${userContext.userData?.uid}`,
      });

      value !== 0
        ? await axios.patch(`/booking/approve/${props.uid}`, { uid: props.uid })
        : await axios.patch(`/booking/${props.bookingId}`, {
            adminApproved: null,
            refPayment: null,
          });
      value === 0 &&
        (await axios.patch(`/booking/deny/${props.uid}`, { uid: props.uid }));

      setStatus(value);
      setIsLoading(false);
      setIsOpenChange(!isOpenChange);
      props.fetchData();
    } catch (error) {
      onError(error as any);
    }
  };
  const CloseModal = () => {
    SetValue(status);
    setIsOpenChange(!isOpenChange);
  };

  const RenderDropdown = statusLabel.map((label, index) => {
    return (
      index !== 2 &&
      index !== 3 && (
        <option key={index} value={statusLabel.indexOf(label)}>
          {label}
        </option>
      )
    );
  });

  return (
    <Container>
      <DropdownButton
        status={status}
        value={status}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => OnChangeModal(e)}
      >
        {value < 2 ? (
          RenderDropdown
        ) : value === 2 ? (
          <option value={statusLabel[status]}>{statusLabel[status]}</option>
        ) : (
          <option value="สำเร็จ">สำเร็จ</option>
        )}
      </DropdownButton>
      <Modal
        isOpen={isOpenChange}
        hideCloseButton
        onRequestClose={CloseModal}
        size="small"
      >
        <ModalContainer>
          {!isLoading ? (
            <React.Fragment>
              <h1>ยืนยันการเปลี่ยนแปลงสถานะ</h1>
              <ExchangeDataContainer>
                <div className="exchange">{statusLabel[status]}</div>
                <ExchangeIcon />
                <div className="exchange">{statusLabel[value]}</div>
              </ExchangeDataContainer>
              <ButtonContainer>
                <ConfirmButton onClick={ConfirmModal}>ยืนยัน</ConfirmButton>
                <CancelButton onClick={CloseModal}>ยกเลิก</CancelButton>
              </ButtonContainer>
            </React.Fragment>
          ) : (
            <Spinner />
          )}
        </ModalContainer>
      </Modal>
    </Container>
  );
};

export default ChangeStatusComponent;
